export default __webpack_public_path__ + "static/media/im-icon.470c455f.svg";